// Need to have access to the queue to see if there are pending transactions
// most of the code comes from '@redux-offline/redux-offline/lib/defaults/queue';
// but adds the ability to request a count of transactions in the queue.

import { getActiveTenantId, getActiveUseCaseId } from './activeScope';

/**
 * Actions queued before these stamps existed carry neither id; they stay sendable so upgrading
 * strands nothing.
 * Each id is checked on its own, so a write queued by a build that recorded only the tenant is
 * still held to that tenant rather than being let through unchecked.
 */
function isSendableNow(item) {
    const { tenantId, useCaseId } = item?.meta ?? {};
    if (tenantId != null && tenantId !== getActiveTenantId()) return false;
    if (useCaseId != null && useCaseId !== getActiveUseCaseId()) return false;
    return true;
}

/**
 *
 * @param {import('../eventSink').EventSink } eventSink
 * @returns
 */
export default function setup(eventSink) {
    let queueCount = 0;
    const [subscribe, publish] = eventSink;
    subscribe({ verb: 'get', namespace: 'application', relation: 'httpqueue' }, payload => {
        publish(
            {
                ...payload,
                queueCount
            },
            { verb: 'get', namespace: 'application', relation: 'httpqueue', status: 'success' }
        );
    });

    function enqueue(array, item) {
        const newQueue = [...array, item];
        queueCount = newQueue.length;
        return newQueue;
    }

    function dequeue(array, completedAction) {
        // peek can hand redux-offline an item that is not the head, so the completed action has to
        // be matched back to the item it came from rather than assuming index 0.
        // Its attempt counts ride on the item, so removing the item is also what forgets them.
        const completedId = completedAction?.meta?.offlineActionId;
        const index = completedId == null ? 0 : array.findIndex(item => item?.meta?.offlineActionId === completedId);
        const rest = index < 0 ? [...array] : [...array.slice(0, index), ...array.slice(index + 1)];
        queueCount = rest.length;
        return rest;
    }

    function peek(array) {
        // Skip - do not drop - writes belonging to a tenant or use case that is not currently
        // active. They stay queued in order and go out when the user returns to that scope.
        return array.find(isSendableNow);
    }

    return {
        enqueue,
        dequeue,
        peek
    };
}

export const _private = { isSendableNow };
